<template>
  <div class="account-form-section-heading">
    <span class="account-form-section-icon"><i :class="icon" aria-hidden="true"></i></span>
    <div class="account-form-section-heading-copy">
      <h5 :id="headingId">{{ title }}</h5>
      <!-- <p>{{ description }}</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserFormSectionHeading',
  props: {
    icon: { type: String, required: true },
    headingId: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true }
  }
}
</script>
